export default __webpack_public_path__ + "static/media/faci14.9d6a7bd5.jpg";